export default "__VITE_ASSET__sB1PAWjw__"